import { IDataOptions } from '@shared/core/common'

export const paramsWithScheduledReminders: IDataOptions = {
  include: ['count_scheduled_reminders'],
}
